//此文件由工具自动生成,不要手动修改此文件
//在/centralsvn/BaseCode/wpcommonEditors/OpenApiAccount.xlsm中修改并生成
//update_time[2022.5.18 10:54:20]

let openApiAccountType = {};

openApiAccountType.getData = function() {
	var data = [
		{
			value : 0,
			label : "微信公众号",
		},
		{
			value : 1,
			label : "微信小程序",
		},
		{
			value : 2,
			label : "企业微信",
		},
		{
			value : 3,
			label : "DmtOpenApi",
		},
		{
			value : 4,
			label : "DmtDataCenter",
		},
		{
			value : 5,
			label : "WebPower邮件",
		},
		{
			value : 6,
			label : "WebPower短信",
		},
		{
			value : 7,
			label : "企业微信事件回调",
		},
		{
			value : 8,
			label : "OSS",
		},
		{
			value : 9,
			label : "WPSH",
		},
		{
			value : 10,
			label : "COS",
		},
	];
	return data;
};

export default openApiAccountType;



// WEBPACK FOOTER //
// ./src/utils/OpenApiAccountType.js